import React, {useEffect, useMemo, useState} from 'react'
import Select from 'react-select'
import axios from 'axios'
import {useAuth} from '../../../modules/auth'

type Props = {
  value: any
  onChange: (subaccounts: any[]) => void
  selectedCustomerIds: Array<string | number>
}

export function ApplicableSubAccountFilter({value, onChange, selectedCustomerIds}: Props) {
  const {currentUser} = useAuth()
  const isRequester = currentUser?.result.userType === 'CONSUMER'
  const [options, setOptions] = useState<{value: any; label: string}[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const parentIds = useMemo(
    () =>
      (selectedCustomerIds ?? [])
        .map((id) => Number(id))
        .filter((id) => !isNaN(id) && id > 0),
    [selectedCustomerIds]
  )

  useEffect(() => {
    if (!isRequester || parentIds.length === 0) {
      setOptions([])
      return
    }

    let cancelled = false
    setIsLoading(true)
    const url = `${process.env.REACT_APP_API_URL}/customer/sub-accounts/shortlist-multi-requester`
    axios
      .post<{data: {code?: number; name?: string; Code?: number; Name?: string}[]}>(url, parentIds)
      .then((response) => {
        if (cancelled) return
        const list = response.data?.data ?? []
        setOptions(
          list.map((d) => ({
            value: d.code ?? d.Code,
            label: d.name ?? d.Name ?? '',
          }))
        )
      })
      .catch(() => {
        if (!cancelled) setOptions([])
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [isRequester, parentIds])

  if (!isRequester || parentIds.length === 0) {
    return null
  }

  const selectedKeys = Array.isArray(value) ? value.map((item: any) => String(item)) : []

  return (
    <div className='col-sm-12 col-md-12'>
      <div className='mb-3'>
        <div className='col-md-12'>
          <label htmlFor='subaccounts' className='form-label fs-7 mb-1'>
            Sub Account(s)
          </label>
        </div>

        <div className='row g-4 g-xl-4'>
          <div className='col-sm-12 col-md-12 col-lg-12'>
            <div className='w-100'>
              <Select
                name='subaccounts'
                className='react-select-styled react-select-solid react-select-sm'
                classNamePrefix='react-select'
                isMulti
                isLoading={isLoading}
                options={options}
                placeholder='Select Sub Account(s)'
                noOptionsMessage={() =>
                  isLoading ? 'Loading...' : 'No sub-accounts for selected customer(s)'
                }
                value={options.filter((option) => selectedKeys.includes(String(option.value)))}
                onChange={(selectedOptions: any) =>
                  onChange(
                    selectedOptions ? selectedOptions.map((option: any) => option.value) : []
                  )
                }
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    width: '100%',
                    maxHeight: '300px',
                    overflow: 'auto',
                    border: '1px solid #e4e6ef',
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
